import { useLayoutEffect } from 'react';

import { createEffectWithTarget } from '#utilities/create-effect-with-target.util';

/**
 * A custom React hook that applies `useLayoutEffect` with a specific target.
 *
 * This hook is created by wrapping `useLayoutEffect` with `createEffectWithTarget`,
 * allowing you to perform side effects that are scoped to a particular target element.
 *
 * @see createEffectWithTarget
 * @see useLayoutEffect
 *
 * @example
 * useLayoutEffectWithTarget(() => {
 *   // Your effect logic here
 * }, [deps], target);
 */
const useLayoutEffectWithTarget = createEffectWithTarget(useLayoutEffect);

export { useLayoutEffectWithTarget };
